App.controller('ZochInsuranceAddCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'zochaInsuranceService', 'statesService', '$filter', 'profileService', 'packageService', 'branchService', 'moment', '$q', 'zochaWorkersService', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, zochaInsuranceService, statesService, $filter, profileService, packageService, branchService, moment, $q, zochaWorkersService, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.data = {};
    $scope.data.user = $scope.stateParams.user;

    /**
     * Model for pesel input in readByPeselForm;
     * @type {string}
     */
    $scope.pesel = '';

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    if ($scope.data.user) {
        $scope.step = 'Wprowadź deklaracje (' + $scope.data.user.person.firstName + ' ' + $scope.data.user.person.lastName + ')';
    } else {
        $scope.step = 'Wprowadź deklaracje';
    }
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.insurance.list';
    $scope.$emit('link', $scope.link);

    $scope.nationality = 'POLISH';

    $scope.packages = [];
    var weight = '';
    packageService.dataPackageLists().then(function (data) {
        if (data.status === 200) {
            var group = data.data.group;

            for (var a = 0; a < group.length; a++) {
                var options = group[a].options;
                for (var b = 0; b < options.length; b++) {
                    $scope.packages.push(options[b]);

                    if (b > 0) {
                        if (options[b - 1].weight > options[b].weight) {
                            weight = options[b].weight;
                        }
                    } else if (b <= 0 && $scope.packageId !== 'undefined') {
                        if ($scope.packageId > options[b].weight) {
                            weight = options[b].weight;
                        }
                    }
                }
            }

            $scope.packageId = $scope.packages[extractKeyValue($scope.packages, 'weight', weight)].id;
            $scope.package = $scope.packages[extractKeyValue($scope.packages, 'weight', weight)];
            $scope.data.benefit = $scope.package;
        }
    });

    $scope.choosePackage = function () {
        $scope.package = $scope.packages[extractKeyValue($scope.packages, 'id', $scope.packageId)];
        $scope.data.benefit = $scope.package;
    }

    function extractKeyValue(obj, subObj, value) {
        for (var key in obj) {
            if (obj[key][subObj] === value) {
                return key;
            }
        }
        return false;
    }

    if ($scope.data.user) {
        $scope.userData = $scope.data.user;

        $scope.selectedItemBranch = $scope.data.user.person.branch;

        $scope.data.person = $scope.userData.person;
        delete $scope.data.person.creationTime;

        $scope.data.userId = $scope.data.user.id;

        console.log($scope.userData);

        if ($scope.userData.person.address) {
            $scope.data.person.address = $scope.userData.person.address;
            delete $scope.data.person.address.creationTime;
            $scope.selectedItemLocalization = $scope.userData.person.address.city;
        }
    } else {
        $scope.data.person = {};
        $scope.data.person.address = {};

        $scope.data.userId = '';
    }

    $scope.acceptStatement = [];
    for (var a = 0; a < 1; a++) {
        $scope.acceptStatement[a] = false;
    }

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    $scope.data.partner = {};
    $scope.data.children = [];

    $scope.accept = function () {
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    }

    $scope.register = function (form) {
        console.log(form);
        if (!form.$valid) {
            return 0;
        }

        var $data = angular.copy($scope.data);

        var childrenLength = Object.keys($data.children).length;
        var partnerLength = ($data.partner && Object.keys($data.partner).length) ? 1 : 0;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                $scope.showPopUp('', 'Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                $scope.showPopUp('', 'Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        if ($data.children && Object.keys($data.children).length) {
            var len = Object.keys($data.children).length;
            for (var a = 0; a < len; a++) {
                if ($data.children[a].member === 'CHILD') {
                    if ($data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver26FromIdentifier')($data.children[a].identifier)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver26FromBirthdate')($data.children[a].birthdate)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    }
                }
            }
        }

        if ($data.partner && Object.keys($data.partner).length) {
            $data.partner.identifierType = ($data.partner.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
            $data.partner.identifier = ($data.partner.nationality !== 'POLISH') ? $data.partner.id : $data.partner.identifier;
            $data.partner.birthdate = ($data.partner.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.partner.birthdate) : $filter('getDateFromIdentifier')($data.partner.identifier);
            $data.partner.citizenshipType = $data.partner.nationality;
            // $data.partner.address.city = $data.partner.selectedItemLocalization;

            delete $data.partner.selectedItemLocalization;
            delete $data.partner.nationality;
            delete $data.partner.id;
            delete $data.partner.sameAddress;
        } else {
            delete $data.partner;
        }

        if ($data.children && Object.keys($data.children).length) {
            var len = Object.keys($data.children).length;
            for (var a = 0; a < len; a++) {

                $data.children[a].identifierType = ($data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                $data.children[a].identifier = ($data.children[a].nationality !== 'POLISH') ? $data.children[a].id : $data.children[a].identifier;
                $data.children[a].birthdate = ($data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.children[a].birthdate) : $filter('getDateFromIdentifier')($data.children[a].identifier);
                $data.children[a].citizenshipType = $data.children[a].nationality;
                // $data.children[a].address.city = $data.children[a].selectedItemLocalization;

                delete $data.children[a].selectedItemLocalization;
                delete $data.children[a].nationality;
                delete $data.children[a].id;
                delete $data.children[a].sameAddress;
            }
        }

        $data.person.identifierType = ($scope.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
        $data.person.identifier = ($scope.nationality !== 'POLISH') ? $data.person.id : $data.person.identifier;
        $data.person.birthdate = ($scope.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.person.birthdate) : $filter('getDateFromIdentifier')($data.person.identifier);
        $data.person.citizenshipType = $scope.nationality;
        // $data.person.address.city = $scope.selectedItemLocalization;
        $data.proposedDate = $scope.proposedDate;
        $data.branch = $scope.selectedItemBranch.name;

        console.log('test2', angular.copy($data));

        zochaInsuranceService.add($data).then(function (data) {
            console.log('test3');
            if (data.status === 200) {
                $scope.showPopUp('', 'Gratulacje!', 'Deklaracja została zgłoszona.', 'Przejdź do listy deklaracji', 'root.home.zoch.insurance.list({"user": null})', 'false');
            } else {
                if (data.data.message === 'DuplicateIdentifierException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Użycie zajętego PESEL/Numer paszportu', content: 'Użytkownik o wskazanym numerze PESEL/Numer paszportu istnieje w systemie. Skontaktuj się z Administratorem.', text: '', target: ''});
                } else if (data.data.message === 'DuplicateEmailException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Użytkownik o wskazanym adresie e-mail istnieje w systemie. Skontaktuj się z Administratorem.', text: '', target: ''});
                } else {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Niestety nie udało się zarejestrować konta. Skontaktuj się z administratorem.', text: '', target: ''});
                }
            }
        });
    }

    $scope.showPopUp = function (ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.add = function (type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                birthdate: new Date('01/01/2000'),
                nationality: 'POLISH',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
        }

        if (type === 'CHILD') {
            $scope.data.children.push({
                birthdate: new Date('01/01/2000'),
                nationality: 'POLISH',
                member: 'CHILD',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            });

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= $scope.package.children) {
                    $scope.children_block = true;
                }
            }
        }
    }

    var getResults = function (query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function (data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function (query) {
        if (!query) {
            return;
        }

        return getResults(query).then(function (results) {
            return results;
        });
    };

    $scope.selectedItemLocalization = null;
    $scope.searchTextLocalization = null;

    $scope.selectedItemMainLocalization = null;
    $scope.searchTextMainLocalization = null;

    $scope.delete = function (obj) {
        if (obj === 'partner') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else {
            $scope.data.children.splice(obj, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        }
    }

    $scope.$watch('data.person.address', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                    }
                }
            }
        }
    }, true);

    $scope.$watch('selectedItemLocalization', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    }
                }
            }
        }
    }, true);

    var collection = ['data.partner.sameAddress', 'data.children[0].sameAddress', 'data.children[1].sameAddress', 'data.children[2].sameAddress', 'data.children[3].sameAddress', 'data.children[4].sameAddress', 'data.children[5].sameAddress'];
    $scope.$watchGroup(collection, function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                } else {
                    // $scope.data.partner.address = {};
                    // $scope.data.partner.selectedItemLocalization = null;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    } else {
                        // $scope.data.children[a].address = {};
                        // $scope.data.children[a].selectedItemLocalization = null;
                    }
                }
            }
        }
    });

    $scope.$watch('notExistEmail', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.notExistEmail) {
                $scope.data.person.email = '';
            }
        }
    });

    var companyId = 1;
    branchService.dataZochBranchLists(companyId).then(function (data) {
        $scope.branch = data.data.data;
    });

    // ##### FILTER ##### //
    $scope.querySearchBranch = function (query) {
        var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    var date = new Date();
    var dayOfMonth = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var requiredDayOfMonth = 25;

    // wyjątek dla drugiego miesiąca przystąpień (06.2018)
    if (month === 6 && year === 2018) {
        requiredDayOfMonth = 29;
    }

    if (dayOfMonth <= requiredDayOfMonth) {
        // to najbliższy
        var date = new Date(date.getFullYear(), date.getMonth() + 1);
        var formattedDate = moment(date).format('YYYY-MM-DD');
        $scope.proposedDate = formattedDate;
    } else {
        // to +1 miesiąc
        var date = new Date(date.getFullYear(), date.getMonth() + 2);
        var formattedDate = moment(date).format('YYYY-MM-DD');
        $scope.proposedDate = formattedDate;
    }

    /**
     * Method findByIdentifier busy indicator;
     * If it's true, method won't be executed;
     * @type {boolean}
     */
    $scope.findPending = false;
    /**
     * Fetches user by identifier (pesel);
     * @param form
     */
    $scope.findByIdentifier = function (form) {
        if (form.$invalid) {
            return;
        }
        if ($scope.findPending) {
            return;
        }
        $scope.findPending = true;

        zochaWorkersService.findByIdentifier($scope.pesel)
            .then(function (success) {
                if (!success.data.data.length) {
                    return;
                }
                var userData = success.data.data[0];
                var userPersonData = userData.person;

                /**
                 * Although this if/else is not necessary here, because it is possible to fetch user by pesel only (polish citizens only);
                 */
                if (userPersonData.identifierType === 'PESEL'
                    || userPersonData.citizenshipType === 'POLISH') {
                    $scope.nationality = 'POLISH';
                } else {
                    $scope.nationality = 'OTHER';
                }

                if (!angular.isDefined(userPersonData.email)
                    || !userPersonData.email) {
                    $scope.notExistEmail = true;
                }

                $scope.selectedItemLocalization = userPersonData.address.city ? {name: userPersonData.address.city} : '';
                $scope.selectedItemBranch = {name: userPersonData.branch};

                $scope.data.branch = userPersonData.branch;
                $scope.data.userId = userData.userId;
                $scope.data.person = {
                    email: userPersonData.email,
                    address: {
                        apartment: userPersonData.address.apartment,
                        number: userPersonData.address.number,
                        street: userPersonData.address.street,
                        zipCode: userPersonData.address.zipCode ? userPersonData.address.zipCode.replace(/-/g, '') : '',
                        city: userPersonData.address.city
                    },
                    identifier: userPersonData.identifier,
                    birthdate: userPersonData.birthdate,
                    firstName: userPersonData.firstName,
                    lastName: userPersonData.lastName,
                    phone: userPersonData.phone,
                };
            })
            .finally(function () {
                $scope.findPending = false;
            });
    }
}]);
